import cookie from 'js-cookie'
import  { router } from '@/main.js'
import api  from '@/api'
import { _types } from './constant'
import routerName from '@/constants/routers'
import Pusher from "pusher-js"
import crypto from "crypto"

window.$crisp=[];
const token_name = process.env.VUE_APP_TOKEN_NAME ? process.env.VUE_APP_TOKEN_NAME : 'swift-token'
const state = {
    token : cookie.get(token_name) ,
    store: null,
    channels: [],
	appPusher: null,
};
const getters = {
    [_types.getters.GET_STORE](state){
        return state.store
    },
    [_types.getters.GET_TOKEN](state){
        return state.token
    },
    [_types.getters.GET_CHANNELS](state){
		return state.channels
    },
    [_types.getters.GET_APP_PUSHER](state){
        return state.appPusher
    },
};

const actions = {
    async [_types.actions.GET_STORE]({commit}){
        try {
            let res =  await api.getStore();
            let { status , data } = res.data
            if( status ){
                commit(_types.mutations.SET_STORE, data )
            }
            return res
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.LOGIN]({} , payload){
        try {
            return await api.login(payload);
        } catch (error) {
            throw error;
        }
    },
    async [_types.actions.SHOPIFY_LOGIN]({} , payload){
        try {
            return await api.handleUrlShopifyLogin(payload)
        } catch (e) {
            throw e;
        }
    },
    async [_types.actions.LOGOUT] ({commit}) {
        commit(_types.mutations.REMOVE_TOKEN)
        router.push({name : routerName.INSTALL_APP})
    },
    async [_types.actions.INIT_LINEBASE]({ commit, state },data) {
        const _store = state.store
        const env = process.env.VUE_APP_ENV;
        const sessionId = crypto.createHash('md5').update(`sw_${env}_${data.shopify_domain}`).digest('hex'); // must be sw_{env}_{shopify_domain} same md5 from BE
        window.LINEBASE_INIT_TRIGGER = async () => {
            if (data){
                // Parse date dd/mm/yy to ISODate
                const parseDateToISO = (dateStr) => {
                    const regex = /^\d{2}\/\d{2}\/\d{2}$/;
                    if (dateStr.match(regex) === null) {
                      return false;
                    }
                    const [day, month, year] = dateStr.split('/');
                    // 👇️ format Date string as `yyyy-mm-dd`
                    const isoFormattedStr = `20${year}-${month}-${day}`;
                    const date = new Date(isoFormattedStr);
                    const timestamp = date.getTime();
                    if (typeof timestamp !== 'number' || Number.isNaN(timestamp)) {
                      return false;
                    }
                  
                    return date.toISOString();
                };

                let arr = []
                for (const property in data) {
                    let datatype = "string";

                    // number value
                    if (["sw_swe_number_of_ticket", "sw_rev", "sw_total_product"].indexOf(property) !== -1) {
                        datatype = "number";
                    }

                    // boolean value
                    if (["sw_status", "sw_swe_status"].indexOf(property) !== -1) {
                        datatype = "boolean";
                        if (data[property] == "false") {
                            data[property] = false;
                        } else if (data[property] == "true") {
                            data[property] = true;
                        }
                    }

                    // datetime value
                    if (["sw_billing_on", "sw_installed", "sw_uninstalled", "sw_first_charge", "sw_swe_last_day"].indexOf(property) !== -1) {
                        datatype = "date";

                        // convert (dd/mm/yy) or correct format date to ISO date
                        const isoDate = parseDateToISO(data[property]);
                        if (isoDate) {
                            data[property] = isoDate;
                        } else if (new Date(data[property]) != "Invalid Date") {
                            data[property] = new Date(data[property]);
                        }
                    }
                    arr.push([property, data[property], datatype])
                }

                const lbContactFirstname = await $linebase.get("contact", "first_name")
                // const lbContactType = await $linebase.get("contact", "type")
                // if (ContactType=Visitor=3) => update contact full_name 
                lbContactFirstname == "Anonymous" && $linebase.set("contact", [["full_name", _store.owner]])

                // set contact general data
                $linebase.set("contact", [
                    ["email", _store.email],
                    ["signed_up", new Date(_store.created_at)],
                    ["hash_id", sessionId],
                ]);

                // set contact attribute value
                $linebase.set("contact", arr, "custom");
            }
        }
        window.LINEBASE_GUEST_ID = sessionId;
        window.LINEBASE_HASH_ID = sessionId;
        window.LINEBASE_ORG_ID = process.env.VUE_APP_LINEBASE_ORG_ID;
        window.LINEBASE_WORKSPACE_ID = process.env.VUE_APP_LINEBASE_WORKSPACE_ID;
        let d = document;
        let s = d.createElement('script');
        s.src = 'https://cw.linebase.io/main.js';
        s.async = 1;
        d.getElementsByTagName('head')[0].appendChild(s);

    },
    async [_types.actions.INIT_CRISP_CHAT]({ commit , state, dispatch }){ 
        let res = await api.getCrispChat()
        let { status, data } = res.data

        //INJECT LB WIDGET  
        // dispatch(_types.actions.INIT_LINEBASE,data)

        window.CRISP_WEBSITE_ID = process.env.VUE_APP_CRISP_WEBSITE_ID || "";
        let arr = []
        let _store = state.store
        window.CRISP_TOKEN_ID = _store.id || '';
        (function(){
            let d=document;
            let s=d.createElement("script");
            s.src="https://client.crisp.chat/l.js";
            s.async=1;
            d.getElementsByTagName("head")[0].appendChild(s);
        })();
        if (status) {
            for (const property in data) {
                arr.push([property, data[property]])
            }
        }
        $crisp.push(["set", "session:data", [arr]]);
        $crisp.push(["set", "user:email", _store.email])
        $crisp.push(["set", "user:nickname", _store.owner])

        // $crisp.push(['do', 'chat:hide']) // hide crisp chat

        
    },
    async [_types.actions.INIT_INTERCOM]({ commit , state }){
        let res = await api.getIntercom()
        let { status, data } = res.data
		if( status ){
			window.Intercom('update', data);
		}
    },
    [_types.actions.DESTROY_INTERCOM]({commit}){
        window.CRISP_TOKEN_ID = undefined
        //CONFIRM
        $crisp.push(["do", "session:reset", [false]])
        $crisp.push(['do', 'chat:hide'])
        // $linebase.do("session", "reset")
        // $linebase.do('widget','hide')
    
        window.Intercom('shutdown')
    },
    [_types.actions.TOGGLE_SHOW_INTERCOM]({}){
        $crisp.push(["do", "chat:toggle"])
        // $linebase.do('widget','toggle')
    },
    [_types.actions.SHOW_INTERCOM]({}, payload){
        if (payload == true) {
			$crisp.push(["do", "chat:open"]);
            // $linebase.do('widget','open')
		} else {
            $crisp.push(["do", "chat:close"]);
            // $linebase.do('widget','close')
		}
    },
    async [_types.actions.HIDE_RATING_BAR]({}, payload) {
        try {
            return await api.hideRatingBar(payload);
        } catch (error) {
            throw error;
        }
    },
    [_types.actions.INIT_PUSHER]({commit, state}) {
        try {
			var pusher = new Pusher(`${process.env.VUE_APP_PUSHER_KEY}`, {
				cluster: "ap1"
			});
			commit(_types.mutations.SET_APP_PUSHER, pusher)
			var channels = [
				{
					'type': 'speedSummary',
					'channelName': `speed-summary-channel-${state.store.id}`,
					'eventName': 'speed-summary'
				}
			]
			commit(_types.mutations.SET_CHANNELS, channels)
			channels.forEach(channel => {
				state.appPusher.subscribe(channel.channelName)
			});
        } catch (error) {
            throw error;
        }
    },
	[_types.actions.DESTROY_PUSHER]({commit, state}, payload) {
		state.channels.forEach(channel => {
			state.appPusher.unsubscribe(channel.channelName)
		});
		commit(_types.mutations.SET_CHANNELS, [])
	},
};

const mutations = {
    [_types.mutations.LOGOUT](state){
        state.token = ''
        cookie.remove(`${token_name}`)
        state.store = null
    },
    [_types.mutations.SET_TOKEN](state, payload = ''){
        state.token = payload
        cookie.set(`${token_name}` , payload , {
            expires: 7
        })
    },
    [_types.mutations.REMOVE_TOKEN](state){
        state.token = ''
        cookie.remove(`${token_name}`)
    },
    [_types.mutations.SET_STORE](state , payload = null ){
        state.store = Object.assign({}, payload)
        window.CRISP_TOKEN_ID = state.store.id;
    },
    [_types.mutations.SET_CHANNELS](state , payload = null ){
        state.channels = payload
    },
    [_types.mutations.SET_APP_PUSHER](state , payload = null ){
        state.appPusher = payload
    },
};
export default {
    state,
    actions,
    mutations,
    getters,
    namespaced: true,
};
